import React from 'react';
import PropTypes from 'prop-types';
import { cssTransition } from 'react-toastify';
import { FaTimes } from 'react-icons/fa';

export const Fade = cssTransition({ enter: 'fadeIn', exit: 'fadeOut' });

export const CloseButton = ({ closeToast }) => (
  <FaTimes
    className="tw-my-2 tw-text-[11px] tw-cursor-pointer tw-opacity-80 hover:tw-opacity-100"
    onClick={closeToast}
  />
);

CloseButton.propTypes = { closeToast: PropTypes.func };
